import React from "react";
import { FormattedMessage } from "react-intl";
import Anchor from "../Anchor";
import styles from "./styles.css";
const ID = "description";
function Description({ city }) {
    return (React.createElement("section", { className: styles.container },
        React.createElement(Anchor, { id: ID, label: React.createElement(FormattedMessage, { id: "DescriptionTitle" }) }),
        React.createElement("p", null,
            "Explore ",
            city,
            " at your own pace with self-guided walking tours and immersive audio stories."),
        React.createElement("p", null,
            "This app is your personal ",
            city,
            " audio guide \u2014 discover iconic landmarks, hidden spots, and local history while you walk. No schedules, no groups, just press play and explore."),
        React.createElement("strong", null, "WHY YOU\u2019LL LOVE IT:"),
        React.createElement("ul", null,
            React.createElement("li", null,
                "Self-guided walking tours in ",
                city),
            React.createElement("li", null, "High-quality audio stories at each stop"),
            React.createElement("li", null, "Works offline \u2014 no internet needed"),
            React.createElement("li", null, "Easy-to-follow routes on your phone"),
            React.createElement("li", null, "Perfect for tourists and solo travelers")),
        React.createElement("strong", null,
            "EXPLORE ",
            city.toUpperCase(),
            " DIFFERENTLY"),
        React.createElement("p", null, "Walk through the city\u2019s most famous areas and uncover stories you wouldn\u2019t find on your own. From historic streets to cultural landmarks, every stop comes with rich audio narration."),
        React.createElement("p", null,
            "Whether it\u2019s your first time in ",
            city,
            " or you want to see it from a new perspective, this app turns your walk into a guided experience."),
        React.createElement("p", null,
            "Download now and start your ",
            city,
            " walking tour.")));
}
;
export default Description;
